import { Inject, Injectable, InjectionToken } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

export const BROWSER_STORAGE = new InjectionToken<Storage>('Browser Storage', {
  providedIn: 'root',
  factory: () => sessionStorage,
});

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  prefix = environment.storagePrefix;

  constructor(@Inject(BROWSER_STORAGE) public storage: Storage, private router: Router) {}

  get(key: string) {
    let data = this.storage.getItem(`${this.prefix}_${key}`) || null;
    return data ? JSON.parse(data) : null;
  }

  getLocal(key: string) {
    let data = localStorage.getItem(`${this.prefix}_${key}`) || null;
    return data ? JSON.parse(data) : null;
  }

  set(key: string, value: string | object) {
    this.storage.setItem(`${this.prefix}_${key}`, JSON.stringify(value));
    localStorage.setItem(`${this.prefix}_${key}`, JSON.stringify(value));
  }

  remove(key: string) {
    this.storage.removeItem(`${this.prefix}_${key}`);
    localStorage.removeItem(`${this.prefix}_${key}`);
  }

  clear() {
    this.storage.clear();
    localStorage.clear();
  }
}
